module.exports = __webpack_public_path__ + "media/bootstrap-icons/joystick-2465f915.svg";